
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/connect/[postId]",
      function () {
        return require("private-next-pages/connect/[postId].tsx");
      }
    ]);
  